// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xScreen } from "@guestsupply/XDL/Utilities";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

export interface CategoryNameStyles {
    categoryTitleWrapper: InjectableCss;
    categoryName: TypographyPresentationProps;
}

const categoryNameStyles: CategoryNameStyles = {
    categoryTitleWrapper: {
        css: css`
            display: flex;
            align-items: baseline;
            width: 100%;
            flex-wrap: wrap;
            padding-bottom: 20px;
            border-bottom: 1px solid ${getColor("common.border")};
            row-gap: 16px;
            ${xScreen("lte", "xs")} {
                flex-direction: column;
                margin-bottom: 10px;
            }
        `,
    },
    categoryName: {
        variant: "h1",
        css: css`
            margin-right: 32px;
            margin-bottom: 0;
            ${xScreen("lte", "sm")} {
                margin-bottom: 12px;
            }
            ${xScreen("lte", "xs")} {
                margin-right: 0;
            }
        `,
    },
};

export default categoryNameStyles;
